import { gql } from '@apollo/client';

export const GET_BRAND_PRODUCT_CATEGORIES = gql`
  query GetBrandProductCategories {
    getBrandProductCategories {
      id
      name
      usedByBrandsCount
    }
  }
`;
